import React from "react";
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  variant?: "primary" | "secondary" | "muted";
}

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-12 w-12",
};

const variantClasses = {
  primary: "border-primary",
  secondary: "border-secondary",
  muted: "border-muted-foreground",
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "md",
  className,
  variant = "primary",
}) => {
  return (
    <div
      className={cn(
        "animate-spin rounded-full border-2 border-transparent",
        sizeClasses[size],
        `${variantClasses[variant]} border-t-transparent`,
        className
      )}
    />
  );
};

interface PageLoadingProps {
  message?: string;
  className?: string;
}

export const PageLoading: React.FC<PageLoadingProps> = ({
  message = "Loading...",
  className,
}) => {
  return (
    <div className={cn("flex items-center justify-center min-h-screen", className)}>
      <div className="flex flex-col items-center gap-4">
        <LoadingSpinner size="lg" />
        {message && (
          <p className="text-sm text-muted-foreground animate-pulse">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

interface SectionLoadingProps {
  message?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const SectionLoading: React.FC<SectionLoadingProps> = ({
  message,
  className,
  size = "md",
}) => {
  return (
    <div className={cn("flex items-center justify-center p-8", className)}>
      <div className="flex flex-col items-center gap-3">
        <LoadingSpinner size={size} />
        {message && (
          <p className="text-sm text-muted-foreground animate-pulse">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};